import { useContext } from "react";
import { OpenExcursionContext } from "../contexts/OpenExcursionContext";

export function useExcursionContext() {
  const context = useContext(OpenExcursionContext);
  if (!context) {
    throw new Error(
      "useExcursionContext must be used within an ExcursionContextProvider"
    );
  }
  return context;
}
